import axios from '@/requests';
import { ProcessResponse } from '@/store/modules/process/types';

export const processAPI = {
    async getProcessListByUid(projId: string, uid: string) {
        try {
            const res = await axios.get<ProcessResponse[]>('/ComputerInfo/getProcessInfoByUid', { "projId": projId, "uid": uid });
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async getOneProcessInfoByUidAndTime(projId: string, uid: string, id: number) {
        try {
            const res = await axios.get<ProcessResponse[]>('/ComputerInfo/getOneProcessInfoByUidAndTime', { "projId": projId, "uid": uid, "id": id });
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    }
}